import apiClient from './api';
// ...

// واجهة جديدة لتعكس بيانات الـ backend
export interface AdminDashboardStats {
  totalLawyers: number;
  totalTrainees: number;
  totalSubscribers: number;
  pendingApprovals: number;
  pendingServiceRequests: number;
  pendingComplaints: number;
  dueInvoices: number;
  monthlyRevenue: number;
}

export const getAdminStats = async (): Promise<AdminDashboardStats> => {
  const response = await apiClient.get<{ data: AdminDashboardStats }>('/dashboard/admin-stats');
  return response.data.data;
};
